/* ============================================================
   fh-product-card.js — Universelt produktkort Fiskehandleren
   Selvinneholdt IIFE, ingen imports, ES5-kompatibel
   ============================================================ */
(function () {
  'use strict';

  // --- Beskytt mot dobbel-init ---
  if (window.__fhpCardBound) return;
  window.__fhpCardBound = true;

  /* ----------------------------------------------------------
     HJELPEFUNKSJONER
  ---------------------------------------------------------- */

  /**
   * Formater en kilopris.
   * @param {number} priceOre  Pris i øre (Shopify-format)
   * @param {number} grams     Vekt i gram fra variant.weight
   * @returns {string}         "X kr/kg" eller ''
   */
  function formatUnitPrice(priceOre, grams) {
    if (!grams || grams <= 0) return '';
    var priceKr = priceOre / 100;
    var weightKg = grams / 1000;
    var perKg = Math.round(priceKr / weightKg);
    return perKg.toLocaleString('nb-NO') + ' kr/kg';
  }

  /**
   * Hent eller opprett toast-element.
   */
  function getToast() {
    var toast = document.querySelector('.fhp-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'fhp-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    return toast;
  }

  /**
   * Vis toast med tekst, skjul etter 2,5 sek.
   * @param {string} msg
   */
  function showToast(msg) {
    var toast = getToast();
    toast.textContent = msg;
    toast.classList.add('is-show');
    clearTimeout(toast.__fhpTimer);
    toast.__fhpTimer = setTimeout(function () {
      toast.classList.remove('is-show');
    }, 2500);
  }

  /**
   * Oppdater alle kjente handlekurv-telle-elementer i headeren.
   * @param {number} count  Totalt antall varer
   */
  function updateCartCount(count) {
    if (count === undefined || count === null || isNaN(count)) return;
    count = parseInt(count, 10);

    var selectors = [
      '[data-cart-count]',
      '.cart-link__bubble',
      '.cart-count-bubble',
      '.header-cart-count',
      '.navlink-cart-count',
      '.cart__count',
      '[data-header-cart-count]'
    ];
    selectors.forEach(function (sel) {
      var els = document.querySelectorAll(sel);
      els.forEach(function (el) {
        var prev = parseInt(el.textContent, 10);
        el.textContent = count;
        if (el.hasAttribute('data-cart-count')) {
          el.setAttribute('data-cart-count', count);
        }
        el.style.display = count > 0 ? '' : 'none';
        if (prev !== count) {
          el.classList.remove('fhp-cart-bump');
          void el.offsetWidth;
          el.classList.add('fhp-cart-bump');
          setTimeout(function () { el.classList.remove('fhp-cart-bump'); }, 500);
        }
      });
    });
  }

  /* ----------------------------------------------------------
     KORTLOGIKK
  ---------------------------------------------------------- */

  /**
   * Oppdater pris, kilopris og variant-ID på et kort basert på en valgt chip.
   * @param {Element} card  [data-fhp-card]
   * @param {Element} chip  [data-fhp-chip]
   */
  function updateCardFromChip(card, chip) {
    var price       = parseInt(chip.getAttribute('data-price'), 10) || 0;
    var compare     = parseInt(chip.getAttribute('data-compare-price'), 10) || 0;
    var grams       = parseInt(chip.getAttribute('data-grams'), 10) || 0;
    var variantId   = chip.getAttribute('data-variant-id');

    // Pris
    var priceEl = card.querySelector('[data-fhp-price]');
    if (priceEl) priceEl.textContent = chip.getAttribute('data-price-html') || formatMoney(price);

    // Sammenlignspris + SPAR
    var compareEl = card.querySelector('[data-fhp-compare]');
    var sparEl    = card.querySelector('[data-fhp-spar]');

    var sparBadge = card.querySelector('[data-fhp-spar-badge]');

    if (compare && compare > price) {
      var savings = compare - price;
      if (compareEl) {
        compareEl.textContent = formatMoney(compare);
        compareEl.style.display = '';
      }
      if (sparEl) {
        sparEl.textContent = 'SPAR ' + formatMoney(savings);
        sparEl.style.display = '';
      }
      if (sparBadge) {
        sparBadge.textContent = 'SPAR ' + formatMoney(savings);
        sparBadge.style.display = '';
      }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (sparEl)    sparEl.style.display    = 'none';
      if (sparBadge) sparBadge.style.display = 'none';
    }

    // Kilopris
    var unitEl = card.querySelector('[data-fhp-unit]');
    if (unitEl) {
      unitEl.setAttribute('data-price', price);
      unitEl.setAttribute('data-grams', grams);
      unitEl.textContent = formatUnitPrice(price, grams);
    }

    // Variant-ID på legg-i-kurv-knappen
    var addBtn = card.querySelector('[data-fhp-add]');
    if (addBtn && variantId) {
      addBtn.setAttribute('data-variant-id', variantId);
    }
  }

  /**
   * Initialiser alle kort på siden:
   * - Sett kilopris fra valgt chip eller enkeltvariant
   * - Sorter chips
   * - Rens chip-tekst
   * - Rens titler
   */
  function initCards() {
    sortChips();
    cleanChipText();
    fixMultiOptionChips();
    stripKgFromTitles();

    var cards = document.querySelectorAll('[data-fhp-card]');
    cards.forEach(function (card) {
      // Sett kilopris fra den allerede valgte chipen (is-selected)
      var selectedChip = card.querySelector('[data-fhp-chip].is-selected');
      if (selectedChip) {
        var price = parseInt(selectedChip.getAttribute('data-price'), 10) || 0;
        var grams = parseInt(selectedChip.getAttribute('data-grams'), 10) || 0;
        var unitEl = card.querySelector('[data-fhp-unit]');
        if (unitEl) unitEl.textContent = formatUnitPrice(price, grams);
        return;
      }
      // Enkeltvariant: sett kilopris fra data-attributter på unit-elementet
      var unitEl = card.querySelector('[data-fhp-unit]');
      if (unitEl) {
        var p = parseInt(unitEl.getAttribute('data-price'), 10) || 0;
        var g = parseInt(unitEl.getAttribute('data-grams'), 10) || 0;
        unitEl.textContent = formatUnitPrice(p, g);
      }
    });
  }

  /**
   * Fjern "X g / " eller "X g/ " prefikser fra chip-tekst.
   * Behold kun vektdelen (f.eks. "5 kg").
   */
  function cleanChipText() {
    var chips = document.querySelectorAll('[data-fhp-chip]');
    chips.forEach(function (chip) {
      var txt = chip.textContent.trim();
      if (txt.indexOf(' / ') !== -1) {
        var parts = txt.split(' / ');
        chip.textContent = parts[parts.length - 1].trim();
      }
    });
  }

  /**
   * Fiks chips for multi-option produkter (f.eks. Kongekrabbe med vekt + størrelse).
   * Sjekker om et chip-container har duplikat-tekst, henter produktdata, og setter full label.
   */
  function fixMultiOptionChips() {
    var containers = document.querySelectorAll('.fh-pi-chips, [data-fhp-chips], [data-fh-pi-chips]');
    containers.forEach(function (container) {
      if (container.dataset.fhChipsFixed) return;
      var chips = Array.prototype.slice.call(container.querySelectorAll('.fh-pi-chip, [data-fhp-chip]'));
      if (chips.length < 3) return;
      var texts = chips.map(function (c) { return c.textContent.trim(); });
      var unique = texts.filter(function (t, i) { return texts.indexOf(t) === i; });
      if (unique.length >= texts.length) return;
      container.dataset.fhChipsFixed = '1';
      var item = container.closest('.product-item, [data-fhp-card]');
      if (!item) return;
      var link = item.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href').split('?')[0];
      fetch(href + '.js').then(function (r) { return r.json(); }).then(function (prod) {
        if (!prod || !prod.variants) return;
        var hasMultiOpt = prod.options && prod.options.length > 1;
        if (!hasMultiOpt) return;
        chips.forEach(function (chip) {
          var vid = chip.getAttribute('data-variant-id');
          if (!vid) return;
          var vidNum = parseInt(vid, 10);
          for (var i = 0; i < prod.variants.length; i++) {
            if (prod.variants[i].id === vidNum) {
              chip.textContent = prod.variants[i].title;
              break;
            }
          }
        });
      }).catch(function () {});
    });
  }

  /**
   * Sorter chips innen hvert chip-container etter pris stigende.
   */
  function sortChips() {
    var containers = document.querySelectorAll('[data-fhp-chips]');
    containers.forEach(function (container) {
      var chips = Array.prototype.slice.call(container.querySelectorAll('[data-fhp-chip]'));
      if (chips.length < 2) return;
      chips.sort(function (a, b) {
        var pa = parseInt(a.getAttribute('data-price'), 10) || 0;
        var pb = parseInt(b.getAttribute('data-price'), 10) || 0;
        return pa - pb;
      });
      chips.forEach(function (c) { container.appendChild(c); });
    });
  }

  /**
   * Fjern " X kg" eller "(X kg)" fra slutten av .fhp__name-tekster.
   */
  function stripKgFromTitles() {
    var names = document.querySelectorAll('.fhp__name');
    names.forEach(function (el) {
      var txt = el.textContent.trim();
      // Fjern avsluttende "(X kg)" eller " X kg"
      txt = txt.replace(/\s*\(\d+[\.,]?\d*\s*kg\)\s*$/i, '').trim();
      txt = txt.replace(/\s+\d+[\.,]?\d*\s*kg\s*$/i, '').trim();
      el.textContent = txt;
    });
  }

  /* ----------------------------------------------------------
     FORMATERING
  ---------------------------------------------------------- */

  /**
   * Formater øre til norsk pengeverdi, f.eks. "1 990,00 kr".
   * @param {number} ore
   * @returns {string}
   */
  function formatMoney(ore) {
    var kr = (ore / 100).toFixed(2);
    var parts = kr.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // narrow no-break space
    return parts.join(',') + ' kr'; // non-breaking space before kr
  }

  /* ----------------------------------------------------------
     EVENT-DELEGATION
  ---------------------------------------------------------- */

  document.addEventListener('click', function (e) {

    /* --------------------------------------------------------
       CHIP-KLIKK
    -------------------------------------------------------- */
    var chip = e.target.closest('[data-fhp-chip]');
    if (chip) {
      var chipCard = chip.closest('[data-fhp-card]');
      if (!chipCard) return;

      // Ikke gjør noe om chipen allerede er valgt eller utilgjengelig
      if (chip.classList.contains('is-selected')) return;
      if (chip.classList.contains('is-unavailable')) return;

      // Oppdater valgt-tilstand
      var allChips = chipCard.querySelectorAll('[data-fhp-chip]');
      allChips.forEach(function (c) { c.classList.remove('is-selected'); });
      chip.classList.add('is-selected');

      // Oppdater pris og variant
      updateCardFromChip(chipCard, chip);
      return;
    }

    /* --------------------------------------------------------
       LEGG I KURV
    -------------------------------------------------------- */
    var addBtn = e.target.closest('[data-fhp-add]');
    if (addBtn) {
      var variantId = addBtn.getAttribute('data-variant-id');
      var productTitle = addBtn.getAttribute('data-product-title') || 'Varen';
      if (!variantId || addBtn.classList.contains('is-loading')) return;

      addBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Feil ved legg i kurv'); });
          return r.json();
        })
        .then(function () {
          // Hent oppdatert handlekurv
          return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          addBtn.classList.remove('is-loading');
          addBtn.classList.add('is-success');

          var cardEl = addBtn.closest('[data-fhp-card]');
          if (cardEl) flyToCart(cardEl);

          updateCartCount(cart.item_count);
          showToast(decodeHtmlEntities(productTitle) + ' lagt i kurven');

          setTimeout(function () {
            addBtn.classList.remove('is-success');
          }, 2000);
        })
        .catch(function (err) {
          addBtn.classList.remove('is-loading');
          showToast(err.message || 'Noe gikk galt. Prøv igjen.');
        });
      return;
    }

    /* --------------------------------------------------------
       ANTALL MINUS (cart context)
    -------------------------------------------------------- */
    var minusBtn = e.target.closest('[data-fhp-qty-minus]');
    if (minusBtn) {
      var itemKey = minusBtn.getAttribute('data-item');
      var qtyEl = minusBtn.closest('.fhp__cart-qty');
      var numEl = qtyEl ? qtyEl.querySelector('[data-fhp-qty-num]') : null;
      var current = numEl ? parseInt(numEl.textContent, 10) : 1;
      if (current <= 1) {
        // Fjern linjen
        changeCartLine(itemKey, 0, numEl, minusBtn);
      } else {
        changeCartLine(itemKey, current - 1, numEl, minusBtn);
      }
      return;
    }

    /* --------------------------------------------------------
       ANTALL PLUSS (cart context)
    -------------------------------------------------------- */
    var plusBtn = e.target.closest('[data-fhp-qty-plus]');
    if (plusBtn) {
      var itemKey2 = plusBtn.getAttribute('data-item');
      var qtyEl2 = plusBtn.closest('.fhp__cart-qty');
      var numEl2 = qtyEl2 ? qtyEl2.querySelector('[data-fhp-qty-num]') : null;
      var current2 = numEl2 ? parseInt(numEl2.textContent, 10) : 1;
      changeCartLine(itemKey2, current2 + 1, numEl2, plusBtn);
      return;
    }

    /* --------------------------------------------------------
       VARIANT-SWAP (cart context — bytt variant i kurven)
    -------------------------------------------------------- */
    var swapBtn = e.target.closest('[data-fhp-swap]');
    if (swapBtn) {
      if (swapBtn.classList.contains('is-selected')) return;
      var newVariant = swapBtn.getAttribute('data-new-variant');
      var oldVariant = swapBtn.getAttribute('data-old-variant');
      var lineKey = swapBtn.getAttribute('data-line-key');
      var swapQty = parseInt(swapBtn.getAttribute('data-qty'), 10) || 1;
      if (!newVariant || !lineKey) return;

      swapBtn.style.opacity = '0.5';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Feil'); });
          return r.json();
        })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(newVariant, 10), quantity: swapQty }] })
          });
        })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Feil'); });
          return r.json();
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function (err) {
          swapBtn.style.opacity = '1';
          showToast(err.message || 'Kunne ikke bytte variant.');
        });
      return;
    }

    /* --------------------------------------------------------
       FJERN LINJEELEMENT (cart context)
    -------------------------------------------------------- */
    var removeBtn = e.target.closest('[data-fhp-remove]');
    if (removeBtn) {
      var itemKey3 = removeBtn.getAttribute('data-item');
      changeCartLine(itemKey3, 0, null, removeBtn);
      return;
    }

  }); // end document click

  /* ----------------------------------------------------------
     HANDLEKURV-ENDRING (antall/fjern)
  ---------------------------------------------------------- */

  /**
   * Endre antall for en linje i handlekurven.
   * @param {string}       lineKey   cart line item key
   * @param {number}       qty       ønsket antall (0 = fjern)
   * @param {Element|null} numEl     element som viser antallet ([data-fhp-qty-num])
   * @param {Element}      triggerEl knappen som ble trykket (for loading-state)
   */
  function changeCartLine(lineKey, qty, numEl, triggerEl) {
    if (triggerEl) triggerEl.classList.add('is-loading');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Feil'); });
        return r.json();
      })
      .then(function (cart) {
        if (triggerEl) triggerEl.classList.remove('is-loading');

        updateCartCount(cart.item_count);

        if (qty === 0) {
          // Fjern kort fra DOM
          var cardEl = triggerEl ? triggerEl.closest('[data-fhp-cart-item]') : null;
          if (cardEl) {
            cardEl.style.transition = 'opacity 0.25s, max-height 0.3s';
            cardEl.style.opacity = '0';
            cardEl.style.overflow = 'hidden';
            cardEl.style.maxHeight = cardEl.offsetHeight + 'px';
            setTimeout(function () {
              cardEl.style.maxHeight = '0';
              cardEl.style.padding = '0';
              cardEl.style.margin = '0';
              cardEl.style.borderBottom = 'none';
              setTimeout(function () { cardEl.remove(); }, 310);
            }, 20);
          }
        } else {
          // Oppdater antall-visning
          if (numEl) numEl.textContent = qty;
        }
      })
      .catch(function (err) {
        if (triggerEl) triggerEl.classList.remove('is-loading');
        showToast(err.message || 'Noe gikk galt.');
      });
  }

  /* ----------------------------------------------------------
     HJELPEFUNKSJON: dekod HTML-entiteter
  ---------------------------------------------------------- */
  /* ----------------------------------------------------------
     FLY-TO-CART ANIMASJON
  ---------------------------------------------------------- */

  function flyToCart(cardEl) {
    var img = cardEl.querySelector('.fhp__img');
    if (!img) return;

    var cartIcon = document.querySelector('.cart-link, [data-cart-count], .navlink-cart, .header__desktop__buttons .navlink[href*="cart"]');
    if (!cartIcon) return;

    var imgRect = img.getBoundingClientRect();
    var cartRect = cartIcon.getBoundingClientRect();

    var clone = document.createElement('div');
    clone.style.cssText =
      'position:fixed;z-index:10000;pointer-events:none;overflow:hidden;' +
      'border-radius:' + Math.min(imgRect.width, imgRect.height) * 0.08 + 'px;' +
      'top:' + imgRect.top + 'px;left:' + imgRect.left + 'px;' +
      'width:' + imgRect.width + 'px;height:' + imgRect.height + 'px;' +
      'background-image:url(' + (img.currentSrc || img.src) + ');' +
      'background-size:cover;background-position:center;' +
      'transition:all 0.55s cubic-bezier(0.2,1,0.3,1);' +
      'box-shadow:0 4px 20px rgba(0,0,0,0.15);';
    document.body.appendChild(clone);

    var targetX = cartRect.left + cartRect.width / 2 - 12;
    var targetY = cartRect.top + cartRect.height / 2 - 12;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clone.style.top = targetY + 'px';
        clone.style.left = targetX + 'px';
        clone.style.width = '24px';
        clone.style.height = '24px';
        clone.style.opacity = '0';
        clone.style.borderRadius = '50%';
        clone.style.boxShadow = 'none';
      });
    });

    setTimeout(function () { clone.remove(); }, 650);
  }


  /* ----------------------------------------------------------
     IMAGE LOAD OBSERVER (shimmer fade-in)
  ---------------------------------------------------------- */

  function observeImages() {
    var grid = document.querySelector('[data-fhp-grid], .collection-products, .product-grid');
    if (grid && !grid.classList.contains('fhp--shimmer')) {
      grid.classList.add('fhp--shimmer');
    }

    var imgs = document.querySelectorAll('.fhp__media .fhp__img');
    var pending = 0;
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-loaded');
      } else {
        pending++;
        function done() {
          img.classList.add('is-loaded');
          pending--;
          if (pending <= 0 && grid) grid.classList.remove('fhp--shimmer');
        }
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });
    if (pending === 0 && grid) grid.classList.remove('fhp--shimmer');
  }


  var _decodeEl;
  function decodeHtmlEntities(str) {
    try {
      if (!_decodeEl) _decodeEl = document.createElement('textarea');
      _decodeEl.innerHTML = str;
      return _decodeEl.value;
    } catch (ex) {
      return str;
    }
  }

  /* ----------------------------------------------------------
     INIT
  ---------------------------------------------------------- */

  function initAll() {
    initCards();
    fixMultiOptionChips();
    observeImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('cart:updated', function () {
    setTimeout(initAll, 100);
  });

  var _labelObserver = new MutationObserver(function () {
    fixMultiOptionChips();
  });
  _labelObserver.observe(document.body, { childList: true, subtree: true });

  // Eksporter init for manuell kall fra andre skript
  window.fhpInitCards = initCards;

})();
